import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import TranslationContainer from '../../../translation/translation_container';
import { Filters } from '../../../../constants/filter/filters';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function Season(props) {
    const opened = props.opened || !!props.seasonValue;
    const seasonTranslationKey = FilterLabelTranslationKeys[Filters.SEASON];
    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline="catalog-filters-section-headline-season"
            containerModifier="season"
        >
            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-season-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.SEASON}
                    value={props.seasonValue}
                    options={props.seasonOptions}
                    labelTranslationKey={seasonTranslationKey}
                    provideAllTranslationKey="catalog-filters-season-select-label-all"
                    onChange={props.onSeasonChange}
                    onToolTipHover={() => props.onToolTipHover('Season')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.seasonValue}
                    unavailableOptions = {[]}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

Season.propTypes = {
    seasonValue: PropTypes.string.isRequired,
    seasonOptions: PropTypes.array.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onSeasonChange: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
};

export { Season };
